import React from 'react';
import { Capacitor } from '@capacitor/core';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import './index.css';
// import './ui-polish.css';

import "./styles/marankoo-redesign.css";
import "./styles/marankoo-capacitor-fixes.css";
import App from './App';
import "./Fonts/IRANSansWeb.woff";
import States from "./context/Context";
import { Provider } from "react-redux";
import configureStore from "../src/Store/index";

if (Capacitor.getPlatform() === 'android' && Capacitor.isNativePlatform()) {
    document.documentElement.classList.add('mk-native-android');
}

ReactDOM.render(
        <BrowserRouter>
            <States>
                <Provider store={configureStore}>
                    <App />
                </Provider>
            </States>
        </BrowserRouter>,
    document.getElementById('root')
);
